
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.623 1l-.006.001L10.612 1h.01zM13 3.4c0 .331-.27.6-.602.6h-1.163v1.2c0 .331-.28.6-.612.6h-.01a.584.584 0 01-.582-.6V4H8.784a.601.601 0 110-1.2h1.246V1.6c0-.33.256-.596.586-.599.33.003.618.27.618.599v1.2h1.163c.332 0 .602.269.602.6zM5.8 8.141l-.025-.001-.026.001A1.202 1.202 0 014.57 6.944a1.203 1.203 0 012.409 0 1.202 1.202 0 01-1.18 1.197zm1.797.356a2.37 2.37 0 00.481-2.263 2.383 2.383 0 00-1.743-1.627 2.41 2.41 0 00-2.969 2.337c0 .595.226 1.134.587 1.553-1.555.633-2.705 2.101-2.947 3.823a.603.603 0 001.193.168c.247-1.744 1.744-3.134 3.55-3.147.009 0 .017.003.026.003.008 0 .016-.003.025-.003 1.807.013 3.303 1.403 3.551 3.148a.596.596 0 00.591.511c.364 0 .652-.32.602-.68-.243-1.721-1.392-3.19-2.947-3.823z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.617 1.001L10.623 1h-.01l.004.001zm0 0a.591.591 0 00-.586.599v1.2H8.785a.602.602 0 00-.425 1.025.601.601 0 00.425.175h1.245v1.2c0 .331.25.6.583.6h.01a.61.61 0 00.612-.6V4h1.163A.601.601 0 0013 3.4c0-.331-.27-.6-.602-.6h-1.163V1.6c0-.33-.287-.596-.618-.599zM5.8 8.141l-.025-.001-.026.001A1.202 1.202 0 014.57 6.944a1.203 1.203 0 012.409 0 1.202 1.202 0 01-1.18 1.197zm1.797.356a2.37 2.37 0 00.481-2.263 2.383 2.383 0 00-1.743-1.627 2.41 2.41 0 00-2.969 2.337c0 .595.226 1.134.587 1.553-1.555.633-2.705 2.101-2.947 3.823a.603.603 0 001.193.168c.247-1.744 1.744-3.134 3.55-3.147.009 0 .017.003.026.003.008 0 .016-.003.025-.003 1.807.013 3.303 1.403 3.551 3.148a.596.596 0 00.591.511c.364 0 .652-.32.602-.68-.243-1.721-1.392-3.19-2.947-3.823z","stroke":"currentColor","stroke-width":".8"}})])
          )
        }
      }
    